import { Accordion, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import Button from "components/atoms/Button/Button";
import Alert from "components/molecules/Alert/Alert";
import { ReactComponent as SortIcon } from "assets/images/icons/SortDown.svg";

import "./DeclinedInvoices.scss";

interface declinedInvoicesProps {
  declinedInvoices: {
    results: {
      shipment_reference: string;
      shipper: string;
      origin: string;
      destination: string;
      invoice_reference: string;
      total_invoice_amount: number;
      invoice_currency: string;
    }[];
  };
}

const DeclinedInvoices = function ({ declinedInvoices }: declinedInvoicesProps) {
  const navigate = useNavigate();

  const [activeKey, setActiveKey] = useState<string | null>("0");

  const renderTableRows = () =>
    declinedInvoices?.results?.map(
      ({ shipment_reference, invoice_reference, shipper, origin, destination, total_invoice_amount, invoice_currency }) => (
        <tr key={shipment_reference}>
          <td className="font-weight-bold">{shipment_reference}</td>
          <td>{shipper}</td>
          <td>
            {origin} <FormattedMessage id="general.to" defaultMessage="to" /> {destination}
          </td>
          <td>
            {total_invoice_amount} {invoice_currency}
          </td>
          <td>
            <Button
              variant="secondary"
              label={<FormattedMessage id="general.resubmit" defaultMessage="Resubmit" />}
              className="ml-auto"
              onClick={() => navigate(`/shipment/${shipment_reference}/billing?invoice=${invoice_reference}`)}
            />
          </td>
        </tr>
      ),
    );

  return (
    <Accordion defaultActiveKey="0" onSelect={(eventKey) => setActiveKey(eventKey)}>
      <Accordion.Toggle as="div" eventKey="0" className="d-flex justify-content-between align-items-center cursor-pointer">
        <Alert variant="danger">
          <span className="font-weight-bold">
            {declinedInvoices.results.length}{" "}
            <FormattedMessage id="billing.declinedInvoices" defaultMessage="declined invoices" />
          </span>
        </Alert>
        <SortIcon fill="#000" width={8} height={7} transform={`rotate(${activeKey === "0" ? 180 : 0})`} />
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="0">
        <div style={{ maxHeight: "500px", overflow: "auto" }}>
          <Table bordered size="sm" className="mt-4 declined-invoices-table">
            <tbody>{renderTableRows()}</tbody>
          </Table>
        </div>
      </Accordion.Collapse>
    </Accordion>
  );
};

export default DeclinedInvoices;
